module.exports = __webpack_public_path__ + "static/mobile-44bf6797309a08d9221c3f916278fb9c.svg";